import axios from 'axios'

// const baseURL="https://tmlh.hentre.top"
const baseURL="https://tmlh.hentre.com"
// const baseURL="https://172.16.8.58:8080/jeecg-boot/"
// const baseURL="/api"
const dologin=`${baseURL}/jeecg-boot/sys/private/login`



  // 子服务器监控
// /server
const getServerLst = `${baseURL}/jeecg-boot/server`
// serverId
const getHostServerLst = `${baseURL}/jeecg-boot/server/service`
const startService = `${baseURL}/jeecg-boot/server/service/start`
const restartService = `${baseURL}/jeecg-boot/server/service/restart`
const stopService = `${baseURL}/jeecg-boot/server/service/stop`
const getHostServerStatus = `${baseURL}/jeecg-boot/server/status`

 

export {
    dologin,
    getServerLst,
    getHostServerLst,
    startService,
    restartService,
    stopService,
    getHostServerStatus
}